
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 500 300"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#009e49","d":"M0 0h500v300H0z"}}),_c('path',{attrs:{"d":"M0 0l500 150L0 300z","fill":"#fff"}}),_c('path',{attrs:{"d":"M0 13.05L456 150 0 286.95z","fill":"#fcd116"}}),_c('path',{attrs:{"d":"M0 0l250 150L0 300z"}}),_c('path',{attrs:{"d":"M0 17.5L220.85 150 0 282.5z","fill":"#ce1126"}})])
          )
        }
      }
    